import { useBillingContext } from '~/contexts/BillingContext'

export function useBillingInfo() {
  const { billingInfo } = useBillingContext()
  return billingInfo
}
